(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sigges-article"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sf-toc]').forEach(function (nav) {
    var body = document.getElementById('sf-prose'); if (!body) return;
    var hs = Array.prototype.slice.call(body.querySelectorAll('h2')).filter(function (h) { return !h.closest('.related'); });
    if (hs.length < 2) return;
    var ol = nav.querySelector('ol');
    hs.forEach(function (h, i) {
      if (!h.id) h.id = 'del-' + (i + 1);
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); ol.appendChild(li);
    });
    nav.hidden = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sigges-coming-soon"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-sf-soon]'); if (!root) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var touch = window.matchMedia('(hover: none)').matches;
    var M = window.Motion;
    var px = -1, py = -1; /* pointer, in px */

    /* ---------- Sea (WebGL) with ripples and depth ---------- */
    var sea = (function () {
      var canvas = root.querySelector('[data-sf-sea]');
      if (!canvas) return null;
      var gl = canvas.getContext('webgl', { antialias: false, alpha: false, powerPreference: 'low-power' });
      if (!gl) { canvas.classList.add('is-still'); return null; }
      var vs = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
      var fs = 'precision highp float;uniform float t;uniform vec2 r;uniform float depth;uniform vec3 rp[8];'
        + 'float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}'
        + 'float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(h(i),h(i+vec2(1,0)),f.x),mix(h(i+vec2(0,1)),h(i+vec2(1,1)),f.x),f.y);}'
        + 'float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<5;i++){v+=a*n(p);p=p*2.05+vec2(1.7,9.2);a*=.5;}return v;}'
        + 'float ridge(vec2 p){float v=0.,a=.55;for(int i=0;i<4;i++){v+=a*(1.-abs(n(p)*2.-1.));p=p*2.1+vec2(3.1,1.3);a*=.5;}return v;}'
        + 'void main(){vec2 uv=gl_FragCoord.xy/r;float asp=r.x/r.y;float tt=t*.06;'
        + 'float rip=0.;for(int i=0;i<8;i++){float age=t-rp[i].z;if(rp[i].z>0.&&age>0.&&age<3.){vec2 d=(uv-rp[i].xy)*vec2(asp,1.);float dist=length(d);float ring=sin(dist*46.-age*7.)*exp(-age*1.4)*exp(-dist*5.)*smoothstep(0.,.15,age);rip+=ring;}}'
        + 'vec2 p=vec2(uv.x*asp*1.3, uv.y*4.2)+rip*.35;'
        + 'float swell=fbm(p*vec2(.6,1.)+vec2(tt*.9,-tt*.2));'
        + 'float w=ridge(p*vec2(.9,1.6)+vec2(-tt*.7,tt*.25)+swell*1.4);'
        + 'float w2=fbm(p*vec2(2.2,3.)+vec2(tt*1.6,tt*.4)+w);'
        + 'vec3 deep=vec3(.106,.141,.118);vec3 em=vec3(.141,.192,.165);vec3 teal=vec3(.184,.365,.42);vec3 cream=vec3(1.,.925,.84);'
        + 'vec3 c=mix(deep,em,smoothstep(.2,.8,swell));'
        + 'c=mix(c,teal,smoothstep(.55,1.,w)*.75);'
        + 'float crest=smoothstep(.62,.72,w2)*smoothstep(.86,.74,w2)*smoothstep(.5,.9,w);'
        + 'c+=cream*crest*.14;'
        + 'c+=cream*clamp(rip,0.,1.)*.12;'
        + 'c=mix(c,deep,smoothstep(.45,1.,uv.y)*.8);'
        /* below the surface: darker, bluer, with caustics */
        + 'float ca=ridge(vec2(uv.x*asp*2.6,uv.y*2.6)+vec2(tt*1.3,-tt*.9));'
        + 'vec3 derby=vec3(1.,.925,.84);vec3 sand=vec3(.95,.87,.76);vec3 blueA=vec3(.80,.89,.92);vec3 blueB=vec3(.64,.80,.84);'
      + 'float ca2=fbm(vec2(uv.x*asp*1.2,uv.y*1.2)+vec2(-tt*.6,tt*.5));'
      + 'vec3 blue=mix(blueA,blueB,smoothstep(.35,.8,ca2));'
      + 'vec3 under=mix(derby,sand,smoothstep(.2,.6,ca2)*.5);'
      + 'under=mix(under,blue,smoothstep(.62,.98,ca)*.9);'
      + 'under+=vec3(1.)*smoothstep(.9,1.,ca)*.18;'
      + 'under+=vec3(1.)*clamp(rip,0.,1.)*.10;'
      + 'c=mix(c,under,depth);'
        + 'gl_FragColor=vec4(c,1.);}';
      function sh(type, src) { var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return s; }
      var prog = gl.createProgram(); gl.attachShader(prog, sh(gl.VERTEX_SHADER, vs)); gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, fs)); gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { canvas.classList.add('is-still'); return null; }
      gl.useProgram(prog);
      var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      var loc = gl.getAttribLocation(prog, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      var uT = gl.getUniformLocation(prog, 't'), uR = gl.getUniformLocation(prog, 'r'), uD = gl.getUniformLocation(prog, 'depth'), uRp = gl.getUniformLocation(prog, 'rp');
      var rips = new Float32Array(24), ri = 0, W = 0, H = 0;
      var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      function size() {
        var scale = dpr * 0.6;
        W = Math.floor(canvas.clientWidth * scale); H = Math.floor(canvas.clientHeight * scale);
        canvas.width = W; canvas.height = H; gl.viewport(0, 0, W, H); gl.uniform2f(uR, W, H);
      }
      size(); window.addEventListener('resize', size);
      return {
        ripple: function (x, y, tsec) { rips[ri * 3] = x; rips[ri * 3 + 1] = 1 - y; rips[ri * 3 + 2] = tsec; ri = (ri + 1) % 8; },
        draw: function (tsec, depth) { gl.uniform1f(uT, tsec + 40); gl.uniform1f(uD, depth); gl.uniform3fv(uRp, rips); gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4); }
      };
    })();

    /* ---------- Fish under the surface ---------- */
    var fishEls = Array.prototype.slice.call(root.querySelectorAll('.sf-fish'));
    var fish = fishEls.map(function (el, i) {
      var w = 90 + (i * 37) % 80; el.style.setProperty('--w', w + 'px');
      var dir = i % 2 ? -1 : 1;
      return { el: el, w: w, dir: dir, x: Math.random() * window.innerWidth, y: 0.45 + (i * 0.11) % 0.4, speed: (10 + (i * 13) % 12) * dir, phase: i * 1.7, up: false };
    });

    /* ---------- Strip: drift + drag + reel + flip ---------- */
    var strip = root.querySelector('[data-sf-strip]'), track = root.querySelector('[data-sf-track]');
    var cards = Array.prototype.slice.call(track.querySelectorAll('.sf-still'));
    var sx = 0, vel = 0, dragging = false, lastX = 0, lastT = 0, moved = 0, half = 0;
    var bubbles = Array.prototype.slice.call(root.querySelectorAll('[data-sf-bubble]'));
    function popBubbles() { bubbles.forEach(function (b) { b.classList.add('is-gone'); }); }
    function measure() { half = track.scrollWidth / 2; }
    measure(); window.addEventListener('resize', measure); window.addEventListener('load', measure);
    strip.addEventListener('pointerdown', function (e) { dragging = true; moved = 0; lastX = e.clientX; lastT = performance.now(); strip.classList.add('is-dragging'); strip.setPointerCapture(e.pointerId); });
    strip.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var now = performance.now(), dx = e.clientX - lastX, dt = Math.max(now - lastT, 1);
      sx += dx; moved += Math.abs(dx); vel = dx / dt * 1000; lastX = e.clientX; lastT = now;
    });
    function endDrag() { if (!dragging) return; dragging = false; strip.classList.remove('is-dragging'); }
    /* With pointer capture the click lands on the strip, so tap-to-flip is resolved on pointerup */
    strip.addEventListener('pointerup', function (e) {
      var was = dragging; endDrag();
      if (!was || moved > 6) return;
      var hit = document.elementFromPoint(e.clientX, e.clientY), card = hit && hit.closest ? hit.closest('.sf-still') : null;
      if (card) { card.classList.toggle('is-flipped'); popBubbles(); if (sea) sea.ripple(e.clientX / window.innerWidth, e.clientY / window.innerHeight, performance.now() / 1000); }
    });
    strip.addEventListener('pointercancel', endDrag); strip.addEventListener('lostpointercapture', endDrag);
    cards.forEach(function (c) {
      c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); c.classList.toggle('is-flipped'); popBubbles(); } });
    });

    /* ---------- Globe: brand-coloured sphere, glowing fishing waters, lines home, live Fångstkort ---------- */
    var globe = root.querySelector('[data-sf-globe]'), gctx = globe && globe.getContext('2d'), globeVisible = false;
    var waters = (globe && globe.dataset.waters ? globe.dataset.waters : '').split('|').map(function (str) {
      var q = str.split(';'); return { name: (q[0] || '').trim(), lat: parseFloat(q[1]), lon: parseFloat(q[2]), what: (q[3] || '').trim(), how: (q[4] || '').trim(), fao: (q[5] || '').trim() };
    }).filter(function (w) { return w.name && !isNaN(w.lat); });
    var homeParts = (globe && globe.dataset.home ? globe.dataset.home : '59.33,18.07').split(','), home = { lat: parseFloat(homeParts[0]), lon: parseFloat(homeParts[1]) };
    var gBase = -0.25 - performance.now() / 1000 * 0.07, gTarget = null, gRot = -0.25, activeW = -1, holdUntil = 0;
    var gTilt = 1.05, tTarget = 1.05, nextTravel = performance.now() + 6500;
    function travelTo(i) { if (!waters[i]) return; setActive(i); gTarget = -waters[i].lon * Math.PI / 180; tTarget = Math.max(-0.9, Math.min(1.2, waters[i].lat * Math.PI / 180)); }
    var fk = root.querySelector('[data-sf-fk]'), fkName = root.querySelector('[data-sf-fk-name]'), fkWater = root.querySelector('[data-sf-fk-water]'), fkWhat = root.querySelector('[data-sf-fk-what]'), fkHow = root.querySelector('[data-sf-fk-how]'), fkFao = root.querySelector('[data-sf-fk-fao]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('.sf-dive__water'));
    function toVec(lat, lon) { var la = lat * Math.PI / 180, lo = lon * Math.PI / 180; return [Math.cos(la) * Math.sin(lo), Math.sin(la), Math.cos(la) * Math.cos(lo)]; }
    function setActive(i) {
      if (i === activeW || !waters[i]) return; activeW = i;
      if (fk) { fk.classList.add('is-swapping'); setTimeout(function () { fkName.textContent = waters[i].name; fkWater.textContent = waters[i].name; fkWhat.textContent = waters[i].what; fkHow.textContent = waters[i].how; if (fkFao) fkFao.textContent = waters[i].fao ? waters[i].name + ' (FAO ' + waters[i].fao + ')' : waters[i].name; fk.classList.remove('is-swapping'); }, 320); }
      chips.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { var i = parseInt(c.dataset.i, 10); if (fk) fk.setAttribute('aria-live', 'polite'); travelTo(i); holdUntil = performance.now() + 12000; nextTravel = holdUntil; }); });
    var gtext = root.querySelector('.sf-dive__globetext'), gPaused = false;
    if (gtext) { gtext.addEventListener('pointerenter', function () { gPaused = true; }); gtext.addEventListener('pointerleave', function () { gPaused = false; nextTravel = performance.now() + 4000; }); gtext.addEventListener('focusin', function () { gPaused = true; }); gtext.addEventListener('focusout', function () { gPaused = false; }); }
    var FAO = [
      { code: '27.I', lat0: 72, lat1: 82, lon0: 26, lon1: 55 },
      { code: '27.IIa', lat0: 62, lat1: 73.5, lon0: -11, lon1: 26 },
      { code: '27.IIb', lat0: 73.5, lat1: 82, lon0: -11, lon1: 30 },
      { code: '27.IIIa', lat0: 55.5, lat1: 59, lon0: 7, lon1: 12.5 },
      { code: '27.IIId', lat0: 53.5, lat1: 66, lon0: 12.5, lon1: 30 },
      { code: '27.IVa', lat0: 57.5, lat1: 62, lon0: -4, lon1: 7 },
      { code: '27.IVb', lat0: 53.5, lat1: 57.5, lon0: -1, lon1: 9 },
      { code: '27.IVc', lat0: 51, lat1: 53.5, lon0: 1, lon1: 5 },
      { code: '27.Va', lat0: 62, lat1: 68, lon0: -27, lon1: -11 },
      { code: '27.Vb', lat0: 60, lat1: 63, lon0: -15, lon1: -4 },
      { code: '27.VI', lat0: 54.5, lat1: 60.5, lon0: -18, lon1: -4 },
      { code: '27.VII', lat0: 48, lat1: 54.5, lon0: -18, lon1: -1 },
      { code: '27.XIV', lat0: 59, lat1: 80, lon0: -44, lon1: -27 }
    ];
    var LAND = [];
    if (globe && globe.dataset.land && window.fetch) fetch(globe.dataset.land).then(function (r) { return r.json(); }).then(function (j) { LAND = j; }).catch(function () {});
    var FAO_MAJOR = [
      { code: '21', lat0: 35, lat1: 78, lon0: -80, lon1: -42 },
      { code: '27', lat0: 36, lat1: 82, lon0: -44, lon1: 68 },
      { code: '31', lat0: 5, lat1: 35, lon0: -98, lon1: -40 },
      { code: '34', lat0: -6, lat1: 36, lon0: -40, lon1: 20 },
      { code: '37', lat0: 30, lat1: 47, lon0: -6, lon1: 42 },
      { code: '41', lat0: -60, lat1: 5, lon0: -70, lon1: -20 },
      { code: '47', lat0: -50, lat1: -6, lon0: -20, lon1: 30 },
      { code: '51', lat0: -45, lat1: 30, lon0: 30, lon1: 80 },
      { code: '57', lat0: -55, lat1: 25, lon0: 80, lon1: 150 },
      { code: '61', lat0: 20, lat1: 65, lon0: 105, lon1: 175 },
      { code: '67', lat0: 40, lat1: 66, lon0: -175, lon1: -120 },
      { code: '71', lat0: -25, lat1: 20, lon0: 100, lon1: 175 },
      { code: '77', lat0: -25, lat1: 40, lon0: -175, lon1: -77 },
      { code: '81', lat0: -60, lat1: -25, lon0: 150, lon1: 255 },
      { code: '87', lat0: -60, lat1: 5, lon0: -120, lon1: -70 }
    ];
    function drawGlobe(tsec) {
      var S = globe.width, R = S * 0.74, cx = S / 2, cy = S * 0.54, tilt = gTilt; /* close-up: the sphere is larger than the canvas; the view travels between the fishing grounds */
      var ct = Math.cos(tilt), st = Math.sin(tilt);
      function proj(v) { var y2 = v[1] * ct - v[2] * st, z2 = v[1] * st + v[2] * ct; return { x: cx + v[0] * R, y: cy - y2 * R, z: z2 }; }
      function rot(v) { var c = Math.cos(gRot), sn = Math.sin(gRot); return [v[0] * c + v[2] * sn, v[1], -v[0] * sn + v[2] * c]; }
      function P(lat, lon) { return proj(rot(toVec(lat, lon))); }
      gctx.clearRect(0, 0, S, S);
      var sph = gctx.createRadialGradient(cx - R * 0.35, cy - R * 0.4, R * 0.1, cx, cy, R);
      sph.addColorStop(0, '#3a6f7d'); sph.addColorStop(0.55, '#224750'); sph.addColorStop(1, '#122328');
      gctx.fillStyle = sph; gctx.beginPath(); gctx.arc(cx, cy, R, 0, Math.PI * 2); gctx.fill();
      /* land: Emerald with a forest-green lit side, cream coastline */
      var landFill = gctx.createRadialGradient(cx - R * 0.3, cy - R * 0.35, R * 0.05, cx, cy, R);
      landFill.addColorStop(0, '#3d5d47'); landFill.addColorStop(0.5, '#2c4536'); landFill.addColorStop(1, '#1b2b22');
      gctx.fillStyle = landFill; gctx.strokeStyle = 'rgba(255,236,214,.35)'; gctx.lineWidth = 0.9; gctx.lineJoin = 'round';
      gctx.save(); gctx.beginPath(); gctx.arc(cx, cy, R, 0, Math.PI * 2); gctx.clip();
      for (var li = 0; li < LAND.length; li++) {
        var ring = LAND[li], anyFront = false; gctx.beginPath();
        for (var pi = 0; pi < ring.length; pi++) {
          var lp = P(ring[pi][1], ring[pi][0]), lx = lp.x, ly = lp.y;
          if (lp.z <= 0) { var dx0 = lx - cx, dy0 = ly - cy, dl = Math.sqrt(dx0 * dx0 + dy0 * dy0) || 1; lx = cx + dx0 / dl * R * 1.02; ly = cy + dy0 / dl * R * 1.02; } else anyFront = true;
          if (pi === 0) gctx.moveTo(lx, ly); else gctx.lineTo(lx, ly);
        }
        if (!anyFront) continue;
        gctx.closePath(); gctx.fill(); gctx.stroke();
      }
      gctx.restore();
      gctx.lineWidth = 0.8; gctx.strokeStyle = 'rgba(255,236,214,.14)';
      function line(pts) { var on = false; gctx.beginPath(); for (var i = 0; i < pts.length; i++) { var p = pts[i]; if (p.z > 0) { if (on) gctx.lineTo(p.x, p.y); else gctx.moveTo(p.x, p.y); on = true; } else on = false; } gctx.stroke(); }
      var pts, lat, lon;
      for (lat = -75; lat <= 75; lat += 15) { pts = []; for (lon = -180; lon <= 180; lon += 4) pts.push(P(lat, lon)); line(pts); }
      for (lon = -180; lon < 180; lon += 15) { pts = []; for (lat = -90; lat <= 90; lat += 4) pts.push(P(lat, lon)); line(pts); }
      var rim = gctx.createRadialGradient(cx, cy, R * 0.86, cx, cy, R * 1.02);
      rim.addColorStop(0, 'rgba(47,93,107,0)'); rim.addColorStop(0.8, 'rgba(47,93,107,.35)'); rim.addColorStop(1, 'rgba(255,236,214,.55)');
      gctx.fillStyle = rim; gctx.beginPath(); gctx.arc(cx, cy, R * 1.02, 0, Math.PI * 2); gctx.fill();
      /* FAO major fishing areas, faint frames with their number */
      gctx.font = '600 ' + Math.round(S * 0.02) + 'px Inter, Helvetica, Arial, sans-serif'; gctx.textAlign = 'center';
      for (var mj = 0; mj < FAO_MAJOR.length; mj++) {
        var B = FAO_MAJOR[mj], ed = [], bla, blo, step = 4;
        for (blo = B.lon0; blo <= B.lon1; blo += step) ed.push(P(B.lat0, blo));
        for (bla = B.lat0; bla <= B.lat1; bla += step) ed.push(P(bla, B.lon1));
        for (blo = B.lon1; blo >= B.lon0; blo -= step) ed.push(P(B.lat1, blo));
        for (bla = B.lat1; bla >= B.lat0; bla -= step) ed.push(P(bla, B.lon0));
        ed.push(ed[0]);
        gctx.setLineDash([2, 6]); gctx.lineWidth = 0.7; gctx.strokeStyle = 'rgba(255,236,214,.16)'; line(ed); gctx.setLineDash([]);
        var bc = P((B.lat0 + B.lat1) / 2, (B.lon0 + B.lon1) / 2);
        if (bc.z > 0.15 && B.code !== '27') { gctx.fillStyle = 'rgba(255,236,214,.3)'; gctx.fillText(B.code, bc.x, bc.y); }
      }
      gctx.textAlign = 'left';
      /* FAO 27 subareas, simplified to their lat/long frames */
      var activeFao = activeW >= 0 && waters[activeW] ? waters[activeW].fao : '';
      var small = globe.clientWidth < 480;
      gctx.font = '600 ' + Math.round(S * 0.024) + 'px Inter, Helvetica, Arial, sans-serif';
      for (var f = 0; f < FAO.length; f++) {
        var A = FAO[f], on = activeFao && (A.code === activeFao || A.code.indexOf(activeFao) === 0 || activeFao.indexOf(A.code) === 0);
        var edge = [], la, lo;
        for (lo = A.lon0; lo <= A.lon1; lo += 2) edge.push(P(A.lat0, lo));
        for (la = A.lat0; la <= A.lat1; la += 2) edge.push(P(la, A.lon1));
        for (lo = A.lon1; lo >= A.lon0; lo -= 2) edge.push(P(A.lat1, lo));
        for (la = A.lat1; la >= A.lat0; la -= 2) edge.push(P(la, A.lon0));
        edge.push(edge[0]);
        if (on) { gctx.fillStyle = 'rgba(47,93,107,.32)'; gctx.beginPath(); var started = false; for (var e = 0; e < edge.length; e++) { if (edge[e].z > 0) { if (started) gctx.lineTo(edge[e].x, edge[e].y); else { gctx.moveTo(edge[e].x, edge[e].y); started = true; } } } gctx.closePath(); gctx.fill(); }
        gctx.setLineDash([3, 5]); gctx.lineWidth = on ? 1.4 : 0.8; gctx.strokeStyle = on ? 'rgba(255,236,214,.85)' : 'rgba(255,236,214,.28)'; line(edge); gctx.setLineDash([]);
        var c = P((A.lat0 + A.lat1) / 2, (A.lon0 + A.lon1) / 2);
        if (c.z > 0.12 && (!small || on)) { gctx.fillStyle = 'rgba(255,236,214,' + (on ? .95 : .6) + ')'; gctx.textAlign = 'center'; gctx.fillText(A.code, c.x, c.y); gctx.textAlign = 'left'; }
      }
      var hv = rot(toVec(home.lat, home.lon)), hp = proj(hv), best = -1, bestZ = 0.15;
      gctx.font = 'italic 500 ' + Math.round(S * 0.036) + 'px Recoleta, Georgia, serif'; gctx.textBaseline = 'middle';
      for (var i = 0; i < waters.length; i++) {
        var w = waters[i], v = rot(toVec(w.lat, w.lon)), p = proj(v);
        if (p.z <= 0.02) continue;
        var a = Math.min(1, (p.z - 0.02) * 2.5), act = i === activeW;
        if (p.z > bestZ) { bestZ = p.z; best = i; }
        var g = gctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, S * (act ? 0.11 : 0.075));
        g.addColorStop(0, 'rgba(47,93,107,' + (a * (act ? .85 : .55)) + ')'); g.addColorStop(1, 'rgba(47,93,107,0)');
        gctx.fillStyle = g; gctx.beginPath(); gctx.arc(p.x, p.y, S * 0.11, 0, Math.PI * 2); gctx.fill();
        var seg = []; for (var k = 0; k <= 24; k++) { var t = k / 24, m = [v[0] + (hv[0] - v[0]) * t, v[1] + (hv[1] - v[1]) * t, v[2] + (hv[2] - v[2]) * t]; var len = Math.sqrt(m[0] * m[0] + m[1] * m[1] + m[2] * m[2]) || 1, lift = 1 + 0.10 * Math.sin(Math.PI * t); seg.push(proj([m[0] / len * lift, m[1] / len * lift, m[2] / len * lift])); }
        gctx.setLineDash([6, 8]); gctx.lineDashOffset = -tsec * 22; gctx.lineWidth = act ? 1.6 : 1; gctx.strokeStyle = 'rgba(255,236,214,' + (a * (act ? .7 : .3)) + ')'; line(seg); gctx.setLineDash([]);
        gctx.fillStyle = 'rgba(197,38,38,' + a + ')'; gctx.beginPath(); gctx.arc(p.x, p.y, S * (act ? 0.013 : 0.01), 0, Math.PI * 2); gctx.fill();
        if (act) { gctx.strokeStyle = 'rgba(255,236,214,' + (a * .7) + ')'; gctx.lineWidth = 1.2; gctx.beginPath(); gctx.arc(p.x, p.y, S * (0.02 + 0.012 * (0.5 + 0.5 * Math.sin(tsec * 2.4))), 0, Math.PI * 2); gctx.stroke(); }
        if (act) { gctx.lineWidth = 5; gctx.strokeStyle = 'rgba(14,26,28,.9)'; gctx.lineJoin = 'round'; gctx.strokeText(w.name, p.x + S * 0.03, p.y - S * 0.02); gctx.fillStyle = 'rgba(255,236,214,1)'; gctx.fillText(w.name, p.x + S * 0.03, p.y - S * 0.02); }
      }
      if (hp.z > 0) { gctx.fillStyle = 'rgba(255,236,214,.95)'; gctx.beginPath(); gctx.arc(hp.x, hp.y, S * 0.007, 0, Math.PI * 2); gctx.fill(); gctx.font = '600 ' + Math.round(S * 0.022) + 'px Inter, Helvetica, Arial, sans-serif'; gctx.fillStyle = 'rgba(255,236,214,.8)'; gctx.fillText('HEM TILL DIG', hp.x + S * 0.016, hp.y + S * 0.016); gctx.font = 'italic 500 ' + Math.round(S * 0.036) + 'px Recoleta, Georgia, serif'; }

    }
    if (globe && 'IntersectionObserver' in window) new IntersectionObserver(function (es) { globeVisible = es[0].isIntersecting; if (globeVisible && activeW < 0) { travelTo(0); nextTravel = performance.now() + 7000; } }, { threshold: 0.05 }).observe(globe);
    else { globeVisible = true; travelTo(0); }

    /* ---------- Dive depth from scroll ---------- */
    var dive = root.querySelector('[data-sf-dive]'), depth = 0;
    function depthNow() {
      if (!dive) return 0;
      var r = dive.getBoundingClientRect(), vh = window.innerHeight;
      return Math.max(0, Math.min(1, (vh - r.top) / (vh * 0.9)));
    }

    /* ---------- Frost on signup ---------- */
    var frost = root.querySelector('[data-sf-frost]'), ice = frost && frost.querySelector('.sf-frost__ice');
    function freeze(hold) {
      if (!frost) return;
      frost.classList.add('is-on');
      if (M && !reduce) {
        M.animate(frost, { opacity: [0, 1] }, { duration: 0.9 });
        M.animate(ice, { transform: ['scale(1.18)', 'scale(1)'] }, { duration: 2.6, ease: [0.2, 0.8, 0.2, 1] });
        M.animate(frost.querySelector('.sf-frost__text'), { opacity: [0, 1], transform: ['translateY(14px)', 'translateY(0)'] }, { delay: 0.6, duration: 0.9 });
      } else frost.style.opacity = 1;
      if (hold) setTimeout(function () { if (M) M.animate(frost, { opacity: 0 }, { duration: 1.2 }).then(function () { frost.classList.remove('is-on'); }); else { frost.style.opacity = 0; frost.classList.remove('is-on'); } }, hold);
    }
    Array.prototype.slice.call(root.querySelectorAll('[data-sf-signup]')).forEach(function (fm) {
      if (fm.querySelector('[data-sf-frozen]')) { setTimeout(function () { freeze(5200); }, 300); return; }
      fm.addEventListener('submit', function (e) {
        if (fm.dataset.sfGo) return;
        var email = fm.querySelector('input[type=email]');
        if (!email || !email.checkValidity()) return;
        e.preventDefault();
        fm.dataset.sfGo = '1'; fm.setAttribute('aria-busy', 'true');
        var ft = frost && frost.querySelector('[data-sf-frost-text]'); if (ft) ft.textContent = 'Vi fryser in din mejl';
        freeze(0);
        /* let the frost be read before the real submit goes off */
        setTimeout(function () { fm.submit(); }, reduce ? 400 : 3200);
      });
    });

    /* ---------- Pointer ---------- */
    var lastRip = 0;
    window.addEventListener('pointermove', function (e) {
      px = e.clientX; py = e.clientY;
      var now = performance.now();
      if (sea && now - lastRip > 90 && !reduce) { sea.ripple(px / window.innerWidth, py / window.innerHeight, now / 1000); lastRip = now; }
    }, { passive: true });
    window.addEventListener('pointerdown', function (e) { if (sea) sea.ripple(e.clientX / window.innerWidth, e.clientY / window.innerHeight, performance.now() / 1000); }, { passive: true });

    /* ---------- Recipe reel: slides sideways every few seconds while visible ---------- */
    var reel = root.querySelector('[data-sf-reel]'), reelItems = reel ? Array.prototype.slice.call(reel.querySelectorAll('[data-sf-reel-item]')) : [];
    var reelDots = reel ? Array.prototype.slice.call(reel.querySelectorAll('.sf-reel__dots i')) : [], reelIdx = 0, reelAt = 0, reelMs = 4600, reelVisible = false;
    if (reel) reel.style.setProperty('--reel-ms', reelMs + 'ms');
    if (reel && 'IntersectionObserver' in window) new IntersectionObserver(function (es) { reelVisible = es[0].isIntersecting; if (reelVisible) reelAt = performance.now(); }, { threshold: 0.3 }).observe(reel);
    else reelVisible = true;
    function reelSetDots() { reelDots.forEach(function (d, i) { d.classList.toggle('is-done', i < reelIdx); d.classList.toggle('is-on', i === reelIdx); }); }
    function reelGo(dir) {
      var n = reelItems.length; if (n < 2) return;
      var cur = reelItems[reelIdx], ni = (reelIdx + dir + n) % n, nxt = reelItems[ni];
      cur.classList.remove('is-active'); cur.classList.add(dir > 0 ? 'is-leaving' : 'is-leaving-r');
      setTimeout(function () { cur.classList.remove('is-leaving', 'is-leaving-r'); }, 900);
      if (dir < 0) { nxt.classList.add('is-from-left'); void nxt.offsetWidth; nxt.classList.remove('is-from-left'); }
      nxt.classList.add('is-active');
      reelIdx = ni; reelSetDots();
    }
    function reelNext() { reelGo(1); }
    if (reel) {
      reel.addEventListener('click', function (e) { var r = reel.getBoundingClientRect(); reelGo((e.clientX - r.left) < r.width * 0.34 ? -1 : 1); reelAt = performance.now(); });
      var reelHover = false; reel.addEventListener('pointerenter', function () { reelHover = true; }); reel.addEventListener('pointerleave', function () { reelHover = false; reelAt = performance.now(); });
    }

    /* ---------- One loop ---------- */
    var last = performance.now(), running = true, gf2 = 0;
    function tick(now) {
      if (!running) return;
      var dt = Math.min(now - last, 50) / 1000; last = now;
      var tsec = now / 1000;
      depth = depthNow();
      if (sea) sea.draw(tsec, 1);

      /* fish */
      var vw = window.innerWidth, vh = window.innerHeight;
      for (var i = 0; i < fish.length; i++) {
        var f = fish[i];
        if (!reduce) f.x += f.speed * dt;
        if (f.x > vw + f.w) f.x = -f.w; if (f.x < -f.w) f.x = vw + f.w;
        var y = (f.y + Math.sin(tsec * 0.6 + f.phase) * 0.03) * vh;
        var dx = px - (f.x + f.w / 2), dy = py - y, near = px >= 0 && (dx * dx + dy * dy) < 150 * 150;
        if (near !== f.up) { f.up = near; f.el.classList.toggle('is-up', near); }
        var wob = Math.sin(tsec * 2.2 + f.phase) * 3;
        f.el.style.transform = 'translate3d(' + f.x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) rotate(' + wob.toFixed(2) + 'deg) scaleX(' + f.dir + ')';
      }

      /* strip */
      if (!dragging) {
        /* no drift of its own: the band only moves when someone pulls it, then rolls out */
        vel *= 0.95; if (Math.abs(vel) < 1.5) vel = 0;
        sx += vel * dt;
      }
      if (half > 0) { while (sx <= -half) sx += half; while (sx > 0) sx -= half; }
      track.style.transform = 'translate3d(' + sx.toFixed(2) + 'px,0,0)';

      /* reel */
      if (reelVisible && !reduce && !reelHover && now - reelAt > reelMs) { reelNext(); reelAt = now; }

      /* globe */
      if (gctx && globeVisible) {
        if (now > nextTravel && !reduce && !gPaused) { travelTo(activeW < 0 ? 0 : (activeW + 1) % waters.length); nextTravel = now + 8000; }
        if (gTarget !== null) { var dif = Math.atan2(Math.sin(gTarget - gRot), Math.cos(gTarget - gRot)); gRot += dif * 0.045; if (Math.abs(dif) < 0.01) { gBase = gRot - tsec * 0.07; gTarget = null; } }
        else if (!reduce) gRot = gBase + tsec * 0.07;
        gTilt += (tTarget - gTilt) * 0.045;
        if ((gf2 = (gf2 || 0) + 1) % 2 === 0) drawGlobe(tsec);
      }

      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
    document.addEventListener('visibilitychange', function () { running = !document.hidden; if (running) { last = performance.now(); requestAnimationFrame(tick); } });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sigges-postnummer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function parseZones(str) {
      return str.split(',').map(function (z) { return z.trim(); }).filter(Boolean).map(function (z) {
        var m = z.match(/^(\d{2,5})\s*-\s*(\d{2,5})$/);
        if (m) return { from: m[1], to: m[2] };
        return { from: z, to: z };
      });
    }
    function coveredByPrefix(code, zones) {
      return zones.some(function (z) {
        var len = z.from.length;
        var head = code.slice(0, len);
        return head >= z.from && head <= z.to;
      });
    }
    var zoneData = null, zonePromise = null;
    function loadZones(url) {
      if (!url) return Promise.resolve(null);
      if (zoneData) return Promise.resolve(zoneData);
      if (!zonePromise) {
        zonePromise = fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) { zoneData = d; return d; }).catch(function () { return null; });
      }
      return zonePromise;
    }
    /* Returnerar 'yes' | 'soon' | 'no'. Exakta postnummer per Gordon-zon i sigges-zones.json; aktiva zoner styrs i temaredigeraren. */
    function lookup(code, data, active, prefixZones) {
      if (data) {
        for (var i = 0; i < active.length; i++) {
          var list = data[active[i]];
          if (list && list.indexOf(code) !== -1) return 'yes';
        }
        var keys = Object.keys(data);
        for (var k = 0; k < keys.length; k++) {
          if (keys[k] === '_meta') continue;
          if (data[keys[k]].indexOf(code) !== -1) return 'soon';
        }
        return 'no';
      }
      return coveredByPrefix(code, prefixZones) ? 'yes' : 'no';
    }
    document.querySelectorAll('[data-sf-pnr]').forEach(function (box) {
      var prefixZones = parseZones(box.dataset.zones || '');
      var active = (box.dataset.active || '1,2,3').split(',').map(function (z) { return z.trim(); }).filter(Boolean);
      var url = box.dataset.zonesUrl;
      var form = box.querySelector('form'), input = box.querySelector('input');
      var wrap = box.querySelector('.sf-pnr__result');
      var res = { yes: box.querySelector('.sf-pnr__res--yes'), soon: box.querySelector('.sf-pnr__res--soon'), no: box.querySelector('.sf-pnr__res--no'), err: box.querySelector('.sf-pnr__res--err') };
      function show(el) {
        Object.keys(res).forEach(function (k) { if (res[k]) res[k].hidden = res[k] !== el; });
        wrap.hidden = false;
        if (window.Motion) window.Motion.animate(el, { opacity: [0, 1], y: [8, 0] }, { type: 'spring', visualDuration: 0.35, bounce: 0.15 });
      }
      function check() {
        var code = (input.value || '').replace(/\D/g, '');
        if (code.length !== 5) { show(res.err); return; }
        input.value = code.slice(0, 3) + ' ' + code.slice(3);
        loadZones(url).then(function (data) {
          var verdict = lookup(code, data, active, prefixZones);
          var target = res[verdict] || res.no;
          target.querySelectorAll('b').forEach(function (b) { b.textContent = b.textContent.replace('[postnummer]', input.value); });
          show(target);
          try { localStorage.setItem('sf-postnummer', code); } catch (e) {}
        });
      }
      form.addEventListener('submit', function (e) { e.preventDefault(); check(); });
      input.addEventListener('focus', function () { loadZones(url); }, { once: true });
      var q = new URLSearchParams(location.search).get('postnummer');
      if (q) { input.value = q; check(); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      else { try { var saved = localStorage.getItem('sf-postnummer'); if (saved) input.value = saved.slice(0, 3) + ' ' + saved.slice(3); } catch (e) {} }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
